/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { registerUser } from "../../services/firebase";
import {
  Typography,
  Container,
  FormControlLabel,
  Checkbox,
  CssBaseline,
} from "@material-ui/core";
import { Link, useNavigate } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AuthContext from "../../hooks/authContext";
import loginBg from "../../assets/images/pc_loginBg.jpg";
import cmsAdminLogo from "../../assets/images/cmsAdminLogo.png";
import RegisterStep1 from "./RegisterStep1";
import RegisterStep2 from "./RegisterStep2";
import RegisterForm from "../../components/auth/RegisterForm";
import AuthLayout from "../../components/auth/AuthLayout";
import { useToast } from "../../hooks/useToast";
import AuthSideContent from "../../components/auth/AuthSideContent";
import useForceLightMode from "../../hooks/useForceLightMode";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const styles = (theme) => ({
  pageroot: {
    background: "url(" + loginBg + ") top center no-repeat",
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    height: "100vh",
    paddingTop: theme.spacing(2),
  },
  paper: {},
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(4),
  },
  submit: {
    margin: theme.spacing(4, 0, 2),
    background: "#078037",
    color: "#fff",
    "&:hover": {
      background: "#078037",
    },
  },
});

const stepsArray = [
  {
    id: 1,
    title: "Create Company Profile",
    subheading: "Step 1",
    content: <></>,
    NextButtonText: "Next",
    CancelButtonText: "Cancel",
  },
  {
    id: 2,
    title: "Company Details",
    subheading: "Step 2",
    content: <></>,
    NextButtonText: "Submit",
    CancelButtonText: "Cancel",
    contentWrapClass: "w-100",
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  complated: {
    background: "#078037",
    color: "#ffffff",
    borderTopColor: "transparent",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    // flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    marginLeft: "auto",
    // fontSize: theme.typography.pxToRem(15),
    // color: theme.palette.text.secondary,
    // opacity: "0.6",
  },
}));

const RegisterUser = (props) => {
  useForceLightMode();
  const [currentStep, setCurrentStep] = useState(1);
  const features = [
    "Catch no-shows before your client does",
    "Deliver GPS-verified proof of every shift",
    "Manage crew accountability across every worksite",
    "Protect your contracts with documented service records",
  ];

  const testimonial = {
    quote:
      "\u201cFor seven years, I operated a cleaning business using tools that were never designed for commercial cleaning. That experience showed me exactly where operators lose time, visibility, and control. I built ProTeams to fix that - and as we've grown from NYC to New Jersey and Dallas, it has become the system I always wished we had.\u201d",
    name: "ProTeams Founder",
    role: "Commercial Cleaning Operator",
  };

  return (
    <AuthLayout
      title="Start your free trial"
      subtitle="Create an account and get full access to all features for 21 days. No credit card required."
      sideContent={
        <AuthSideContent
          title="Built for commercial operators, by a commercial operator."
          features={features}
          testimonial={testimonial}
        />  
      }
      register={true}
      currentStep={currentStep}
    >
      <RegisterForm {...props} setCurrentStep={setCurrentStep} currentStep={currentStep} />
    </AuthLayout>
  );
};

const RegisterUser1 = (props) => {
  const auth = useContext(AuthContext);
  const styles = useStyles();
  let navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState({});
  const [error, setError] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [state, setState] = useState({
    formState: { username: "", password: "" },
    loading: false,
    sRedirect: "",
    terms: "",
  });
   const { toast } = useToast();

  const goToStep = (step) => {
    setCurrentStep(step);
  };

  const goNext = () => {
    let newStep =
      currentStep < stepsArray?.length ? currentStep + 1 : currentStep;
    setCurrentStep(newStep);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name !== "") {
      setState({ ...state, formState: { ...state.formState, [name]: value } });
    }
  };

  const handleCancelAll = () => {
    setState({ formState: {} });
  };

  const redirecifloggedin = () => {
    navigate("/dashboard");
  };
  useEffect(() => {
    if (auth.status === true) {
      redirecifloggedin();
    }
  }, [auth.status]);

  const onChangeCheckbox = (event) => {
    setState({
      ...state,
      terms: event.target.checked ? event.target.value : false,
    });
  };

  const industry = [
    // { label: "Automotive Services – Auto Detailing", value: "mu6e3gfFqfHp4NSoyCA1" },
    { label: "Building Cleaning & Maintenance", value: "NRop745hbvB5nFNo3gy9" },
    { label: "Cleaning (General Residential/Commercial)", value: "Ivs5bvNvTXa5sMIs1nZT" },
    // { label: "Construction – Carpentry", value: "tdyBKdunNfi0f3xrC7Iy" },
    // { label: "Construction – Concrete Installation", value: "cM1eWLu4UbaYuKvs6Kcr" },
    // { label: "Construction – Construction", value: "HU5h5EHSJo1JvFcGg7cy" },
    // { label: "Construction – Demolition Contractor", value: "VMhraTGmurcXZ1OATTVJ" },
    // { label: "Construction – Drywall", value: "GVD36PcjQQcspbln6xQ0" },
    // { label: "Construction – Electrical Contracting", value: "wuiSBFWKRsM75FqNEcBo" },
    // { label: "Construction – Excavation", value: "xav1bVq4fYR8b5kgzc5d" },
    // { label: "Construction – Fence Services", value: "KfJnjHPOakLNIHzmbY2y" },
    // { label: "Construction – Flooring", value: "zFDtbfJNAbZ8lhaNQl4Q" },
    // { label: "Construction – General Contracting", value: "TVnyzcsD8RfUhijixbUN" },
    // { label: "Construction – HVAC (Heating, Ventilation, Air Conditioning)", value: "rnEoBRDepCz7J3gnI8kA" },
    // { label: "Construction – Installation Services", value: "V42FN0qCRZXI07qycCUF" },
    // { label: "Construction – Mechanical Contracting", value: "5pJN3Iem0pfg31PJj47U" },
    // { label: "Construction – Painting", value: "38Puv1318ZhpfYWlUY2s" },
    // { label: "Construction – Paving", value: "oGS0vlEcp6QrHlmIA3IE" },
    // { label: "Construction – Plumbing", value: "V3lIZitKwTFCHY0HNaaQ" },
    // { label: "Construction – Remodeling", value: "aW8PzalzERgtnLa6geQI" },
    // { label: "Construction – Roofing", value: "zF1tROpWwKsyldlubPBt" },
    // { label: "Construction – Tiling", value: "fYKFimqm94OSLlW98jhH" },
    // { label: "Construction / Repair Services – Garage Door Services", value: "uyJoyW6gw2gFTZSdx2zf" },
    { label: "Facility Services / Cleaning – Carpet Cleaning", value: "M9nZBPyb2aKohbrP55NB" },
    { label: "Facility Services / Cleaning – Commercial Cleaning", value: "1LlqChnpKLjIcv5gbGoO" },
    { label: "Facility Services / Cleaning – House Cleaning", value: "RuAl2ezrCubTM3aEL3Yv" },
    { label: "Facility Services / Cleaning – Janitorial Services", value: "fj1B99lgi87CW1HufILB" },
    { label: "Facility Services / Cleaning – Pressure Washing", value: "Sqn38RboF5eSdc7jtLj8" },
    { label: "Facility Services / Cleaning – Window Cleaning", value: "UMhjyNIDJmQWXDKD3Sw7" },
    // { label: "Facility Services / Maintenance – Property Maintenance", value: "INTO7y64buuAGdcqg1f2" },
    // { label: "Landscaper", value: "9R3Yx2bsCaAbr0SHxWMj" },
    // { label: "Landscaping - Grounds Maintenance", value: "LNdzWlDMt9gqWjgobMl8" },
    // { label: "Landscaping – Irrigation Services", value: "APGiW09l1CwUiCNLaur4" },
    // { label: "Landscaping – Landscaping", value: "OKcFRK1jEKZFUdRQ4MQ7" },
    // { label: "Landscaping – Lawn Care", value: "I3BJfwh9ZeTCzIQUB6Ht" },
    // { label: "Landscaping – Tree Care", value: "NB55s9Y9MnQlcLvkqWm1" },
    // { label: "Mechanical & Plumbing Services", value: "81tUSZ4CkQq0wVcEgou1" },
    // { label: "Municipal / Landscaping – Snow Removal", value: "OCxWpKcb70TqpresiJkR" },
    // { label: "Pest Management Services – Pest Control", value: "u20LKUdquxmhnykEB6dY" },
    // { label: "Pet Services – Dog Walking", value: "99PU9Yi6ShAVJkzmDon6" },
    // { label: "Pet Services – Pooper Scooper (Pet Waste Removal)", value: "Q4geLTvo62qUYlrONcPM" },
    // { label: "Recreational Services / Specialty – Pool & Spa Services", value: "0A4Pka6d3lzDXeYfauUa" },
    // { label: "Repair and Maintenance – Handyman", value: "vUAzEwF9QRH6ZHKCxE7n" },
    // { label: "Repair Services – Appliance Repair", value: "UQtrSo3Xi5gxhrRQw9An" },
    // { label: "Security Services – Locksmith Services", value: "YMQcJqRrcy3jfClMbR0y" },
    // { label: "Specialty Restoration Services – Restoration (Fire & Water Damage)", value: "BCxqV6OwlLA2WGv7jrGv" },
    // { label: "Specialty Trade Contractors – Chimney Sweep Services", value: "IVQY0PNcsqNcij7ELPMO" },
    // { label: "Specialty Trade Contractors – Elevator Services", value: "J20mHvlO5v1tzFHP33mb" },
    // { label: "Utilities Services – Well Water Services", value: "XsRyy6P7dhLZMVgit2Ie" },
    // { label: "Waste Management – Junk Removal", value: "t1g3B5fLTa4N6Rks4ywr" }
  ];
  const showErrorMessage = (message) => {
    setError(message);
    setState({ ...state, sRedirect: "", loading: false });
  };

  const userRegister = async (e) => {
    e.preventDefault();
    setError("");
    setState({ ...state, loading: true });
    const { terms } = state;
    const {
      companyName,
      firstname,
      lastname,
      username,
      phoneNumber,
      email,
      password,
      confirmpassword,
      peoples,
      industry,
      website,
      country,
      phoneCountryCode,
      timeZone,
      companyCity,
      companyState,
      companyZip,
      companyAddress,
    } = state.formState;
    const emails = email;
    const names = firstname;
    const passwords = password;
    if (terms !== "yes") {
      showErrorMessage("Please Agree with terms");
    } else {
      let newuser = await registerUser({
        companyName: companyName,
        firstName: firstname,
        lastName: lastname,
        email: email,
        username: username,
        phoneNumber: phoneNumber,
        website: website,
        peoples: peoples,
        industry: industry,
        password: password,
        confirmPassword: confirmpassword,
        createdAt: new Date().toISOString(),
        role: "companyUser",
        teamAdminSeat: true,
        country,
        phoneCountryCode,
        timeZone,
        companyCity,
        companyState,
        companyZip,
        companyAddress,
      });
      if (newuser?.uid) {
        // User account created successfully in Firebase
        // The registerUser function has already sent a verification email
        
        // Wait for backend processing to complete
        await delay(3500);
        
        // Set registration completion flag for VerificationSent.jsx
        // This flag triggers a 60-second resend cooldown on the page
        localStorage.setItem("verify", "true");
        localStorage.setItem(
          "pendingRegistrationEmail",
          (email || "").trim().toLowerCase()
        );

        // Redirect to verification confirmation page
        // User will see their email address and instructions to verify
        // When they click the verification link, it goes to:
        // FirebaseActionHandler → /verify-email → applyActionCode → /login
        navigate("/verify-email-sent");
        setState({ ...state, loading: false });

        // const { subject, content } = EmailTemplate({
        //   subject: "Welcome to ProTeams.io!",
        //   headline: "Welcome to ProTeams.io",
        //   content: `
        //   <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; max-width: 600px; margin: auto; border: 1px solid #eee; border-radius: 10px;">
          
        //   <div style="text-align: center; margin-bottom: 20px;">
        //   <img src="https://${DOMAINURL}/csmGrayTextLogin.png" alt="ProTeams.io Logo" style="height: 60px;" />
        //   </div>

        //   <p style="margin-bottom: 16px;">Hi ${names},</p>
          
        //     <p style="margin-bottom: 24px;">
        //       Welcome to ProTeams.io! Your 21-day free trial is now active, and you're all set to begin optimizing your workforce management. Whether you're overseeing service teams, facilities personnel, or field operators, ProTeams.io equips you with the tools to stay organized, efficient, and in control.
        //     </p>

        //     <p style="margin-bottom: 16px;">Here are a few ways to make the most of your trial:</p>

        //     <ul style="margin: 16px 0; padding-left: 20px;">
        //       <li style="margin-bottom: 12px;">Create your first team - Add members and assign roles to get started quickly.</li>
        //       <li style="margin-bottom: 12px;">Explore the scheduler - Simplify daily coordination and shift planning.</li>
        //       <li style="margin-bottom: 12px;">Utilize workflows and task assignments - Streamline operations with ease.</li>
        //       <li style="margin-bottom: 12px;">Manage clients and track issues - Stay responsive and proactive with built-in tools.</li>
        //     </ul>

        //     <p style="margin-bottom: 24px;">
        //       Need assistance? Our support team is here to help. If you'd like a personalized walkthrough, simply reply to this email—we'd be happy to schedule a session.
        //     </p>

        //     <p style="margin-bottom: 24px;">
        //       Thank you for choosing ProTeams.io. We're excited to support your success.
        //     </p>
        //     </div>
        //   `,
        // });

        // const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };
        // const res = await axiosInstance.post(
        //   `${BaseUrl}sendEmailData`,
        //   {
        //     email: emails,
        //     subject: subject,
        //     contenttxt: content,
        //   },
        //   {
        //     headers: {
        //       "Content-Type": "application/json",
        //       withCredentials: true,
        //       ...authHeaders,
        //     },
        //   }
        // );
      } else {
        showErrorMessage(newuser?.message);
      }

      // await register(
      //   {
      //     firstname: firstname, lastname: lastname, email: email, username: username,
      //     phonenumber: phonenumber, country: country,
      //     password: password, confirmPassword: confirmpassword
      //   },
      //   (res) => {
      //     if (res?.data?.status === true) {
      //       auth.login(res?.data?.token);
      //       setState({ ...state, loading: false });
      //       history('/dashboard');
      //     } else {
      //       showErrorMessage(res?.data?.message);
      //     }
      //   },
      //   (resError) => {
      //     showErrorMessage(resError?.message || "Something Went Wrong!");
      //   }
      // );
    }

    setState({ ...state, loading: false });
  };

  const { formState, loading, sRedirect } = state;
  const { classes } = props;
  return (
    <div className={classes.pageroot}>
      {sRedirect !== "" && <Navigate to={sRedirect} />}
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div
          className={`${classes.paper} loginwrap sectionBox`}
          style={{ width: "590px" }}
        >
          <img className="cmslogo" src={cmsAdminLogo} alt="PROTeam Login" />
          <form className={classes.form} noValidate>
            <div className="clientWidth">
              <div className="stepformwrap">
                <RegisterStep1
                  currentStep={currentStep}
                  goToStep={goToStep}
                  classes={styles}
                  formState={formState}
                  handleInputChange={handleInputChange}
                  handleCancelAll={handleCancelAll}
                  setErrorMessage={setErrorMessage}
                  errorMessage={errorMessage}
                  goNext={goNext}
                />

                <RegisterStep2
                  currentStep={currentStep}
                  goToStep={goToStep}
                  classes={styles}
                  formState={formState}
                  handleInputChange={handleInputChange}
                  handleCancelAll={handleCancelAll}
                  userRegister={userRegister}
                  industry={industry}
                  setErrorMessage={setErrorMessage}
                  errorMessage={errorMessage}
                  loading={loading}
                />
              </div>
            </div>
            <div className="loginbottom">
              <FormControlLabel
                control={
                  <Checkbox
                    value="yes"
                    color="primary"
                    checked={Boolean(state?.terms ? state?.terms : false)}
                    onChange={onChangeCheckbox}
                  />
                }
                label={
                  <span>
                    I confirm that I have read and agree to the{" "}
                    <a
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="color-Darkblue text-underLine"
                    >
                      Terms and Conditions
                    </a>
                    .
                  </span>
                }
              />
            </div>
            <Typography className="text-center" variant="body2">
              Already have an account?
              <Link
                to="/login"
                style={{
                  textDecoration: "underline",
                  color: "#078037",
                  fontSize: "16px",
                  fontWeight: "bold",
                  gap: "8px",
                }}
              >
                {" "}
                Sign In
              </Link>
            </Typography>
            {error !== "" && (
              <Typography className="text-center" color="error" variant="body2">
                {error}
              </Typography>
            )}
          </form>
        </div>
      </Container>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(RegisterUser);
